import React, { FunctionComponent, useEffect, useState } from "react"
import { connect } from "react-redux"
import { TextToSpeechVoices } from "../../api/TextToSpeechVoices"
import { iSelectOptionType } from "../../definitions/interfaces"
import SliderInput from "../Form/Inputs/SliderInput"
import SelectInput from "../Form/Select/Select"
import s from "./TextToSpeech.less"

interface iProps {
  onCreate?: (data: any) => void
  text: string
}

const voiceTypes = [
  { value: "WAVENET", label: "WaveNet" },
  { value: "BASIC", label: "Basic" },
]
const languages = TextToSpeechVoices.map((x) => x.languageCode)

const TextToSpeech: FunctionComponent<iProps> = ({ onCreate, text }) => {
  const [names, setNames] = useState<iSelectOptionType<string>[]>([])
  const [selectedLanguage, setSelectedLanguage] = useState<string>("")
  const [selectedName, setSelectedName] = useState<string>("")
  const [selectedType, setSelectedType] = useState<string>("")
  const [speed, setSpeed] = useState<number>(1)
  const [pitch, setPitch] = useState<number>(0)
  useEffect(() => {
    const init = TextToSpeechVoices.find(
      (x) => x.languageCode.value === "en-US",
    )
    if (init) {
      const initialNames = init.wavenetNames
      setSelectedName(initialNames[0])
      setNames(initialNames.map((x) => ({ value: x, label: x })))
      setSelectedLanguage(init.languageCode.value)
    }
  }, [])

  const onCreateClicked = () => {
    const data: any = {
      input: {
        text,
      },
      audioConfig: {
        audioEncoding: "mp3",
        speakingRate: speed,
        pitch,
      },
    }
    data.voice = {
      languageCode: selectedLanguage,
      name: selectedName,
    }

    onCreate && onCreate(data)
  }

  const setAudioSpeed = (value: any) => {
    setSpeed(value[0])
  }

  const setAudioPitch = (value: any) => {
    setPitch(value[0])
  }
  const languageSelected = (value: string) => {
    const lang = TextToSpeechVoices.find((x) => x.languageCode.value === value)
    if (lang) {
      if (selectedType === "BASIC" && lang.basicNames) {
        setSelectedName(lang.basicNames[0])
        setNames(lang.basicNames.map((x) => ({ label: x, value: x })))
      } else {
        setSelectedName(lang.wavenetNames[0])
        setNames(lang.wavenetNames.map((x) => ({ label: x, value: x })))
      }
      setSelectedLanguage(value)
    }
  }
  const voiceTypeSelected = (value: string) => {
    setSelectedType(value)
    const lang = TextToSpeechVoices.find(
      (x) => x.languageCode.value === selectedLanguage,
    )
    if (lang) {
      if (value === "BASIC" && lang.basicNames) {
        setNames(lang.basicNames.map((x) => ({ label: x, value: x })))
        setSelectedName(lang.basicNames[0])
      } else {
        setNames(lang.wavenetNames.map((x) => ({ label: x, value: x })))
        setSelectedName(lang.wavenetNames[0])
      }
    }
  }

  const nameSelected = (value: string) => {
    setSelectedName(value)
  }

  return (
    <div className={`${s.textToSpeech} gradient-border`}>
      <div className="form-group">
        <button
          className="btn btn-blue"
          onClick={onCreateClicked}
          type={"button"}
        >
          Create audio for description
        </button>
      </div>
      <div className="row">
        <div className="col-12">
          <p className="text-center">
            For more information about Text-to-Speech click{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://cloud.google.com/text-to-speech/"
            >
              here
            </a>
            .
          </p>
        </div>
        <div className="col-6">
          <SelectInput
            key={`languages-${languages.length}`}
            label={"Language / locale"}
            name="languages"
            value={languages.find((x) => x.value == "en-US")}
            isClearable={false}
            options={languages}
            onChange={languageSelected}
          />
        </div>
        <div className="col-6">
          <SelectInput
            label={"Voice Type"}
            name="voiceType"
            isClearable={false}
            value={voiceTypes[0]}
            options={voiceTypes}
            onChange={voiceTypeSelected}
          />
        </div>
        <div className="col-12">
          <SelectInput
            key={`names-${selectedName}`}
            label={"Voice Name"}
            isClearable={false}
            value={names.length > 0 && names[0]}
            name="names"
            options={names}
            onChange={nameSelected}
          />
        </div>
        <div className="col-6">
          <label>Speed</label>
          <SliderInput
            name="speed"
            value={0}
            start={speed}
            range={{ min: 0.25, max: 4 }}
            step={0.25}
            tooltips
            onChange={setAudioSpeed}
          />
        </div>
        <div className="col-6">
          <label>Pitch</label>
          <SliderInput
            name="pitch"
            value={0}
            start={pitch}
            range={{ min: -20, max: 20 }}
            step={0.4}
            tooltips
            onChange={setAudioPitch}
          />
        </div>
      </div>
    </div>
  )
}

export default connect()(TextToSpeech)
